var isProduction = process.env.NODE_ENV === 'production'

/**
 * 项目配置项
 */
export default {
  ProjectName: 'common_web',
  AjaxUrl: isProduction ? '' : 'http://114.55.141.145:8304/',
  // 导航分组
  navGroup: [{
    groupCode: 0,
    label: 'Content Manage',
    href: '/Welcome'
  }, {
    groupCode: 1,
    label: 'System Manage',
    href: '/AdminUserInfo'
  }]
}



// WEBPACK FOOTER //
// ./src/components/common/config.js